/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var emofaBackendApp = angular.module('emofa.backed', ['gettext', 'ngMessages', 'ngSanitize', 'ngResource', 'ngRoute', 'ngStorage', 'ui.router', 'ui.grid', 'lbServices', 'angularModalService', 'ui-notification']);

emofaBackendApp.config(["$httpProvider", "$stateProvider", "$resourceProvider", "$urlRouterProvider", "LoopBackResourceProvider", "NotificationProvider", function ($httpProvider, $stateProvider, $resourceProvider, $urlRouterProvider, LoopBackResourceProvider, NotificationProvider) {

  $resourceProvider.defaults.stripTrailingSlashes = false;
  $httpProvider.defaults.withCredentials = true;
  $urlRouterProvider.otherwise('/login');

  LoopBackResourceProvider.setAuthHeader('X-Access-Token');
  LoopBackResourceProvider.setUrlBase('https://order.emofa.ch/api');

  $stateProvider.state('login', {
    url: '/login',
    templateUrl: 'https://order.emofa.ch/app/modules/login/LoginView.html',
    controller: 'LoginCtrl as LoginCtrl'
  }).state('password-forgotten', {
    url: '/password-forgotten',
    templateUrl: 'https://order.emofa.ch/app/modules/login/PasswordForgottenView.html',
    controller: 'PasswordForgottenCtrl as PasswordForgottenCtrl'
  }).state('password-reset', {
    url: '/password-reset/:token',
    templateUrl: 'https://order.emofa.ch/app/modules/login/PasswordResetView.html',
    controller: 'PasswordResetCtrl as PasswordResetCtrl'
  }).state('app', {
    url: '/app',
    templateUrl: 'https://order.emofa.ch/app/modules/main/MainView.html',
    abstract: true,
    controller: 'MainCtrl as MainCtrl',
    resolve: {
      role: ["$sessionStorage", function role($sessionStorage) {
        return $sessionStorage.userRole;
      }]
    }
  }).state('app.start', {
    url: '/start',
    templateUrl: 'https://order.emofa.ch/app/modules/start/StartView.html',
    controller: 'StartCtrl as StartCtrl'
  }).state('app.user', {
    url: '/user',
    templateUrl: 'https://order.emofa.ch/app/modules/user/UserView.html',
    controller: 'UserCtrl as UserCtrl',
    resolve: {
      user: ["AppUser", function user(AppUser) {
        return AppUser.find({
          where: {
            location: {
              near: {
                lat: 42.266271,
                lng: -72.6700016
              },
              maxDistance: 2
            }
          }
        }).$promise;
      }]
    }
  }).state('app.feedback', {
    url: '/feedback',
    templateUrl: 'https://order.emofa.ch/app/modules/comment/CommentView.html',
    controller: 'CommentCtrl as CommentCtrl'
  }).state('app.orderlist', {
    url: '/order/:type',
    templateUrl: 'https://order.emofa.ch/app/modules/order/OrderListView.html',
    controller: 'OrderListCtrl as OrderListCtrl',
    resolve: {
      items: ["$sessionStorage", "Item", function items($sessionStorage, Item) {
        if ($sessionStorage.stock && $sessionStorage.stock.length) {
          return $sessionStorage.stock;
        } else {
          return Item.list().$promise.then(function (response) {
            $sessionStorage.stock = response.data;
            return response.data;
          });
        }
      }]
    }
  }).state('app.shipment', {
    url: '/shipment',
    templateUrl: 'https://order.emofa.ch/app/modules/order/ShipmentView.html',
    controller: 'ShipmentCtrl as ShipmentCtrl'
  }).state('app.cart', {
    url: '/cart',
    templateUrl: 'https://order.emofa.ch/app/modules/order/CartView.html',
    controller: 'CartCtrl as CartCtrl',
    resolve: {
      items: ["$sessionStorage", function items($sessionStorage) {
        return $sessionStorage.items;
      }]
    }
  }).state('app.settings', {
    url: '/settings',
    templateUrl: 'https://order.emofa.ch/app/modules/settings/SettingsView.html',
    controller: 'SettingsCtrl as SettingsCtrl',
    resolve: {
      user: ["AppUser", function user(AppUser) {
        return AppUser.getCurrent().$promise;
      }]
    }
  }).state('app.logout', {
    url: '/logout',
    controller: ["$state", "AppUser", function controller($state, AppUser) {
      AppUser.logout({}, {}, function () {
        $state.go('login');
      }, function (error) {
        console.error(error);
      });
    }]
  });

  $httpProvider.interceptors.push(["$q", "$location", "LoopBackAuth", function ($q, $location, LoopBackAuth) {
    return {
      responseError: function responseError(rejection) {
        if (rejection.status === 401) {
          LoopBackAuth.clearUser();
          LoopBackAuth.clearStorage();
          $location.nextAfterLogin = $location.path();
          $location.path('/login');
        }
        return $q.reject(rejection);
      }
    };
  }]);

  NotificationProvider.setOptions({
    delay: 4000,
    startTop: 20,
    startRight: 10,
    verticalSpacing: 20,
    horizontalSpacing: 20,
    positionX: 'center',
    positionY: 'bottom'
  });
}]);

emofaBackendApp.run(["$rootScope", "$transitions", "gettextCatalog", function ($rootScope, $transitions, gettextCatalog) {
  var lang = 'de';
  var userLang = (navigator.language || navigator.userLanguage || 'de').toLowerCase();

  $transitions.onSuccess({}, function (transition) {
    var toState = transition.to().name;
    $rootScope.currentState = toState;
  });

  if (userLang.indexOf('de') > -1) {
    lang = 'de';
  } else if (userLang.indexOf('it') > -1) {
    lang = 'it';
  } else if (userLang.indexOf('fr') > -1) {
    lang = 'fr';
  }

  gettextCatalog.loadRemote('/i18n/' + lang + '.json');
  gettextCatalog.setCurrentLanguage(lang);
}]);

emofaBackendApp.controller('LoginCtrl', __webpack_require__(1));
emofaBackendApp.controller('PasswordResetCtrl', __webpack_require__(2));
emofaBackendApp.controller('PasswordForgottenCtrl', __webpack_require__(3));
emofaBackendApp.controller('StartCtrl', __webpack_require__(4));
emofaBackendApp.controller('MainCtrl', __webpack_require__(5));
emofaBackendApp.controller('UserCtrl', __webpack_require__(6));
emofaBackendApp.controller('OrderListCtrl', __webpack_require__(7));
emofaBackendApp.controller('CommentCtrl', __webpack_require__(8));
emofaBackendApp.controller('CartCtrl', __webpack_require__(9));
emofaBackendApp.controller('SettingsCtrl', __webpack_require__(10));
emofaBackendApp.controller('YesNoController', __webpack_require__(11));
emofaBackendApp.controller('ShipmentCtrl', __webpack_require__(12));

emofaBackendApp.value('settings', __webpack_require__(13));

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LoginCtrl = function LoginCtrl(AppUser, $state, $sessionStorage) {
    this._AppUser = AppUser;
    this._state = $state;
    this._sessionStorage = $sessionStorage;
    this.credentials = {};
    this.hasErrors = false;
    this.formSubmitted = false;
};

LoginCtrl.prototype.login = function () {
    var self = this;

    this.formSubmitted = true;

    this._AppUser.login(this.credentials, function (response) {
        self._state.go('app.orderlist', { type: 'scooter' });
        self._sessionStorage.userRole = response.role;
        self._sessionStorage.username = response.user.username;
    }, function (error) {
        self.hasErrors = true;
        console.log('error', error);
    });
};

module.exports = LoginCtrl;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var PasswordResetCtrl = function PasswordResetCtrl(gettextCatalog, AppUser, $state, $stateParams, Notification) {
  this._AppUser = AppUser;
  this._state = $state;
  this._Notification = Notification;
  this.gettextCatalog = gettextCatalog;
  this.credentials = {};
  this.hasErrors = false;
  this.formSubmitted = false;
  this._accessToken = $stateParams.token;
};

PasswordResetCtrl.prototype.send = function () {
  var self = this;
  this._AppUser.setPassword({
    access_token: this._accessToken
  }, this.credentials, function () {
    self._Notification.success(self.gettextCatalog.getString('Passwort zurückgesetzt'));
    self._state.go('login');
  }, function () {
    self._Notification.error(self.gettextCatalog.getString('Passwort konnte nicht zurückgesetzt werden'));
  });
};

module.exports = PasswordResetCtrl;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var PasswordForgottenCtrl = function PasswordForgottenCtrl(gettextCatalog, AppUser, $state, Notification) {
  this._AppUser = AppUser;
  this._state = $state;
  this._Notification = Notification;
  this.gettextCatalog = gettextCatalog;
  this.credentials = {};
  this.hasErrors = false;
  this.formSubmitted = false;
};

PasswordForgottenCtrl.prototype.send = function () {
  var self = this;
  this._AppUser.resetPassword(this.credentials, function () {
    self._Notification.success(self.gettextCatalog.getString('Eine E-Mail mit weiteren Informationen wurde an {{email}} gesendet.', { email: self.credentials.email }));
  }, function () {
    self._Notification.error(self.gettextCatalog.getString('Passwort Reset fehlgeschlagen. Bitte wenden Sie sich an unseren Support.'));
  });
};

module.exports = PasswordForgottenCtrl;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var StartCtrl = function StartCtrl() {};

module.exports = StartCtrl;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var MainCtrl = function MainCtrl($rootScope, $sessionStorage, role) {
    var self = this;
    this.role = role;
    this.itemsLen = $sessionStorage.items ? $sessionStorage.items.length : 0;
    this.username = $sessionStorage.username;

    $rootScope.$watch(function () {
        return $sessionStorage.items ? $sessionStorage.items.length : 0;
    }, function (itemsLen) {
        self.itemsLen = itemsLen;
    });
};

module.exports = MainCtrl;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var UserCtrl = function UserCtrl(gettextCatalog, user) {
    this.gridOptions = {
        data: user,
        enableFiltering: true,
        columnDefs: [{
            field: 'email',
            enableColumnMenu: false,
            displayName: gettextCatalog.getString('Email')
        }, {
            field: 'username',
            enableColumnMenu: false,
            displayName: gettextCatalog.getString('Firma')
        }]
    };
};

module.exports = UserCtrl;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OrderListCtrl = function OrderListCtrl($scope, $state, $stateParams, gettextCatalog, items, Notification, $sessionStorage, ModalService) {
  var _this = this;

  var self = this;
  this.items = items;
  this._state = $state;
  this.gettextCatalog = gettextCatalog;
  this._Notification = Notification;
  this._sessionStorage = $sessionStorage.$default({
    items: [],
    deliveryType: 'shipping'
  });
  this.orderedItems = this._sessionStorage.items;
  var ersatzteile = gettextCatalog.getString('Ersatzteile');
  this.filter = {
    name: '',
    number: ''
  };
  this.type = $stateParams.type;
  this._ModalService = ModalService;

  if (this.type === 'scooter') {
    this.filteredItems = this.items.filter(function (item) {
      return item.type === 'scooter';
    });
  } else if (this.type === 'part') {
    this.filteredItems = this.items.filter(function (item) {
      return item.type === 'part';
    });
  } else {
    this.filteredItems = [];
  }

  $scope.$watch(function () {
    return self.filter;
  }, function (newValue, oldValue) {
    var filter = {};

    if (newValue === oldValue) {
      return;
    }

    if (self.filterScooter) {
      filter.article_group_id = self.filterScooter;
    } else if (self.filteParts) {
      filter.article_group_id = self.filteParts;
    }

    if (newValue.name) {
      filter.intern_name = newValue.name;
    }

    if (newValue.number) {
      filter.intern_code = newValue.number;
    }

    _this.filteredItems = self.items.filter(function (item) {
      if (filter.article_group_id && item.article_group_id !== filter.article_group_id) {
        return false;
      }

      if (filter.intern_name && filter.intern_code) {
        return item.intern_name.indexOf(filter.intern_name) > -1 && item.intern_code.indexOf(filter.intern_code) > -1;
      } else if (filter.intern_name) {
        return item.intern_name.indexOf(filter.intern_name) > -1;
      } else if (filter.intern_code) {
        return item.intern_code.indexOf(filter.intern_code) > -1;
      } else {
        return true;
      }
    });
  }, true);

  this.parts = [{ label: ersatzteile + ' E-Jeek', id: 3 }, { label: ersatzteile + ' E-Mine', id: 4 }, { label: ersatzteile + ' Emofa', id: 19 }, { label: ersatzteile + ' Emofa 320', id: 6 }, { label: ersatzteile + ' Emofa 330', id: 5 }, { label: ersatzteile + ' Emofa 3XX', id: 12 }];

  this.scooter = [{ label: 'E-Business', id: 17 }, { label: 'E-Business-Power', id: 18 }, { label: 'E-Climber', id: 14 }, { label: 'E-Cruiser', id: 30 }, { label: 'E-Delivery', id: 31 }, { label: 'E-Falcon', id: 35 }, { label: 'E-Fun', id: 29 }, { label: 'E-Jeek', id: 9 }, { label: 'E-Kelly', id: 28 }, { label: 'E-Liberty', id: 36 }, { label: 'E-Mine', id: 8 }, { label: 'E-Rider', id: 39 }, { label: 'E-Sporty', id: 37 }, { label: 'E-Start', id: 32 }, { label: 'E-Stream', id: 38 }, { label: 'E-Töffli Power', id: 34 }, { label: 'E-Töffli', id: 33 }, { label: 'E-Young', id: 16 }, { label: 'Emofa 300', id: 13 }, { label: 'Emofa 320', id: 11 }, { label: 'Emofa 330', id: 10 }];

  this.gridOptions = {
    data: this.filteredItems,
    enableFiltering: true,
    onRegisterApi: function onRegisterApi(gridApi) {
      self.gridApi = gridApi;
    },
    columnDefs: [{
      field: 'intern_name',
      enableColumnMenu: false,
      displayName: gettextCatalog.getString('Art.-Name')
    }, {
      field: 'intern_code',
      enableColumnMenu: false,
      displayName: gettextCatalog.getString('Art.-Nummer')
    }, {
      field: 'sale_price',
      enableColumnMenu: false,
      enableFiltering: false,
      maxWidth: 150,
      displayName: gettextCatalog.getString('Händlerpreis')
    }, {
      field: 'intern_description',
      enableColumnMenu: false,
      enableFiltering: false,
      displayName: gettextCatalog.getString('Verkaufspreis Endkunde'),
      cellTemplate: '<div class="ui-grid-cell-contents" ng-bind-html="row.entity[col.field]"></div>',
      minWidth: 400
    }, {
      field: 'stock_available_nr',
      enableColumnMenu: false,
      enableFiltering: false,
      displayName: gettextCatalog.getString('Lagerbestand'),
      maxWidth: 120
    }, {
      field: 'id',
      enableColumnMenu: false,
      displayName: gettextCatalog.getString('Bestellen'),
      enableFiltering: false,
      maxWidth: 120,
      cellTemplate: '<div class="ui-grid-cell-contents text-center" data-ng-click="grid.appScope.OrderListCtrl.add(row.entity)"><span class="dripicons-cart" aria-hidden="true" data-icon></span></div>'
    }]
  };
};

OrderListCtrl.prototype.updateFilter = function (type) {
  if (type === 'scooter') {
    this.filteParts = null;
    this.filteredItems = _.filter(this.items, { article_group_id: this.filterScooter });
  } else if (type === 'part') {
    this.filterScooter = null;
    this.filteredItems = _.filter(this.items, { article_group_id: this.filteParts });
  }
};

OrderListCtrl.prototype.getName = function (item) {
  var nameParts = item.intern_name ? item.intern_name.split('/') : [];
  return nameParts.length ? nameParts[0] : item.intern_name;
};

OrderListCtrl.prototype.add = function (item) {
  var self = this;
  var cartItem = _.find(this._sessionStorage.items, { id: item.id });
  this._Notification.success(this.gettextCatalog.getString('{{menge}} x {{artikel}} hinzugefügt', { menge: item.order_number, artikel: item.intern_name }));

  if (!cartItem) {
    this._sessionStorage.items.push(angular.copy(item));
  } else {
    cartItem.order_number += item.order_number;
  }

  item.order_number = 1;

  this._ModalService.showModal({
    templateUrl: "https://order.emofa.ch/app/modules/order/YesNoModalView.html",
    controller: "YesNoController as YesNoController"
  }).then(function (modal) {
    modal.element.modal();
    modal.close.then(function (result) {
      if (result) {
        self._state.go('app.shipment');
      }
    });
  });
};

OrderListCtrl.prototype.changeAmount = function (item, amount) {
  item.order_number += amount;

  if (amount === 1) {
    item.order_number = Math.min(item.order_number, item.stock_available_nr);
  } else if (amount === -1) {
    item.order_number = Math.max(item.order_number, 1);
  }
};

module.exports = OrderListCtrl;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var CommentCtrl = function CommentCtrl(gettextCatalog, Feedback, Notification) {
    this._Feedback = Feedback;
    this._Notification = Notification;
    this.gettextCatalog = gettextCatalog;
    this.model = {
        goodScooter: '',
        badScooter: '',
        perfectScooter: '',
        declineReason: '',
        buyingReason: '',
        equipment: '',
        complaints: ''
    };
};

CommentCtrl.prototype.send = function () {
    var self = this;

    this._Feedback.create(this.model, function () {
        self._Notification.success(self.gettextCatalog.getString('Feedback eingereicht'));
    }, function () {
        self._Notification.error(self.gettextCatalog.getString('Feedback konnte nicht eingereicht werden'));
    });
};

module.exports = CommentCtrl;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var CartCtrl = function CartCtrl(gettextCatalog, $state, $sessionStorage, Notification, items, Order) {
  this._Notification = Notification;
  this._Order = Order;
  this._state = $state;
  this._sessionStorage = $sessionStorage;
  this.gettextCatalog = gettextCatalog;
  this.items = items;
  this.deliveryItems = [];
  this.sum = 0;
  var allScooter = this._sessionStorage.items.every(function (item) {
    return item.type === 'scooter';
  });
  this.type = allScooter ? 'scooter' : 'part';

  this.deliveryTypeChanged();
};

CartCtrl.prototype.order = function () {
  var self = this;

  this._Order.create({
    items: this.items,
    deliveryItems: this.deliveryItems,
    comment: this.comment
  }, function () {
    self._Notification.success(self.gettextCatalog.getString('Besten Dank für Ihre Bestellung. Die Auftragsbestätigung erhalten Sie per Email.'));
    self._sessionStorage.$reset({
      items: [],
      stock: [],
      deliveryType: null
    });
    self._state.go('app.orderlist', { type: 'scooter' });
  }, function () {
    self._Notification.error(self.gettextCatalog.getString('Bestellung konnte nicht abgesendet werden'));
  });
};

CartCtrl.prototype.removeItem = function (index) {
  this.items.splice(index, 1);

  this.deliveryTypeChanged();
};

CartCtrl.prototype.deliveryTypeChanged = function () {
  if (this._sessionStorage.deliveryType === 'shipping') {
    this.generateDeliveryItems();
  } else {
    this.deliveryItems = [];
  }

  this.calcSum();
};

CartCtrl.prototype.isDisabled = function () {
  return !this.agb;
};

CartCtrl.prototype.generateDeliveryItems = function () {
  var self = this;
  this.deliveryItems = [];
  var partSum = 0;

  _.forEach(this.items, function (item) {
    if (item.type === 'part') {
      partSum += _.toNumber(item.sale_price) * _.toNumber(item.order_number);
    } else if (item.type === 'scooter') {
      self.deliveryItems.push({
        intern_name: 'Lieferkosten für ' + item.intern_name,
        sale_price: _.toNumber(item.deliverer_description) * _.toNumber(item.order_number),
        type: 'deliveryCosts'
      });
    }
  });

  // if (partSum > 0 && partSum < 200) {
  //   this.deliveryItems.push({
  //     intern_name: 'Lieferpauschale Ersatzteile',
  //     sale_price: 15,
  //     type: 'deliveryCosts'
  //   });
  // }
};

CartCtrl.prototype.calcSum = function () {
  var self = this;
  this.sum = 0;

  _.forEach(this.items, function (item) {
    self.sum += _.toNumber(item.sale_price) * _.toNumber(item.order_number);
  });

  _.forEach(this.deliveryItems, function (item) {
    self.sum += _.toNumber(item.sale_price);
  });
};

module.exports = CartCtrl;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SettingsCtrl = function SettingsCtrl(gettextCatalog, user, AppUser, Notification) {
  this.model = user;
  this.modelPassword = {};
  this.gettextCatalog = gettextCatalog;
  this._AppUser = AppUser;
  this._Notification = Notification;
};

SettingsCtrl.prototype.changePassword = function () {
  var self = this;

  this._AppUser.changePassword(this.modelPassword, function () {
    self._Notification.success(self.gettextCatalog.getString('Passwort geändert'));
  }, function () {
    self._Notification.error(self.gettextCatalog.getString('Passwort konnte nicht geändert werden. Das alte Passwort war nicht korrekt.'));
  });
};

module.exports = SettingsCtrl;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var YesNoCtrl = function YesNoCtrl($scope, close, gettextCatalog) {
  $scope.close = function (result) {
    close(result, 500);
  };
};

module.exports = YesNoCtrl;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ShipmentCtrl = function ShipmentCtrl(gettextCatalog, $state, $sessionStorage, Notification) {
  this._Notification = Notification;
  this._state = $state;
  this.sessionStorage = $sessionStorage;
  this.gettextCatalog = gettextCatalog;
  this.hasScooter = this.sessionStorage.items.some(function (item) {
    return item.type === 'scooter';
  });
  this.hasParts = this.sessionStorage.items.some(function (item) {
    return item.type === 'scooter';
  });
};

ShipmentCtrl.prototype.goToCart = function () {
  this._state.go('app.cart');
};

module.exports = ShipmentCtrl;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    apiBase: 'https://order.emofa.ch/api'
};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// emofa.min.js